'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _config = require('./config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignUpMetadataManager = function () {
  function SignUpMetadataManager(options) {
    (0, _classCallCheck3.default)(this, SignUpMetadataManager);

    this.options = options;
  }

  (0, _createClass3.default)(SignUpMetadataManager, [{
    key: 'getAll',
    value: function getAll() {
      return (0, _keys2.default)(_config.PARAMS_COOKIE_NAMES).reduce(function (data, paramName) {
        var fieldValue = _jsCookie2.default.get(_config.PARAMS_COOKIE_NAMES[paramName]);

        // add metadata field only if its not empty
        if (fieldValue) {
          data[paramName] = fieldValue;
        }

        return data;
      }, {});
    }
  }, {
    key: 'cleanAll',
    value: function cleanAll() {
      var _this = this;

      (0, _keys2.default)(_config.PARAMS_COOKIE_NAMES).forEach(function (paramName) {
        _jsCookie2.default.remove(_config.PARAMS_COOKIE_NAMES[paramName], { domain: _this.options.cookiesDomain });
      });
    }
  }, {
    key: 'save',
    value: function save(data) {
      var _this2 = this;

      (0, _keys2.default)(data).forEach(function (key) {
        _this2.validateParam(key);

        var cookieName = _config.PARAMS_COOKIE_NAMES[key];
        var value = data[key];

        if (key in _config.COOKIES_EXPIRATION) {
          _jsCookie2.default.set(cookieName, value, { domain: _this2.options.cookiesDomain, expires: _config.COOKIES_EXPIRATION[key] });
        } else {
          _jsCookie2.default.set(cookieName, value, { domain: _this2.options.cookiesDomain });
        }
      });
    }
  }, {
    key: 'validateParam',
    value: function validateParam(param) {
      var allowedParams = (0, _keys2.default)(_config.PARAMS_COOKIE_NAMES);

      if (allowedParams.indexOf(param) === -1) {
        throw new Error('Invalid metadata param passed. Allowed params: ' + allowedParams.join(', '));
      }
    }
  }]);
  return SignUpMetadataManager;
}();

exports.default = SignUpMetadataManager;
//# sourceMappingURL=signup-metadata.js.map